import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { AuthService } from '@services/auth.service';
import { NavigationService } from '@services/navigation.service';
import { Observable, of } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
/**
 * Guards routes that should only be accessible when the user is NOT logged in.
 * If the user is logged in, they are redirected to the home page.
 */
export class PublicGuard {
  constructor(
    private authService: AuthService,
    private router: Router,
    private navigationService: NavigationService,
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    const token = this.authService.getJwtToken();
    if (token && !this.authService.isTokenExpired(token)) {
      this.navigationService.navigateToSpaces();
      return of(false);
    }
    return of(true);
  }
}
